import {makeGetHealthOpenScheduling} from 'main/factories/usecases/private/booking-flow/remote-health-booking';
import {GetHealthOpenSchedulingParams, GetHealthOpenSchedulingModel} from 'domain/usecases';

export const getHealthOpenScheduling = async (
	params: GetHealthOpenSchedulingParams,
): Promise<GetHealthOpenSchedulingModel> => makeGetHealthOpenScheduling().get(params);
